export const checkPermission = (
  routeRole: string | string[],
  userRole: string | string[],
): boolean => {
  if (!routeRole) return true;

  if (!userRole) return false;

  const requiredRoles = Array.isArray(routeRole) ? routeRole : [routeRole];

  const userRoles = Array.isArray(userRole) ? userRole : [userRole];

  return requiredRoles.some((role) => userRoles.includes(role));
};

export const getRoute = (route: string, params?: Record<string, string>) => {
  return route.replace(/:(\w+)/g, (match, p1) => params[p1] || match);
};
